export type RunningOrderMaterialSummary = {
  articleNumber: string
  description: string
  quantityPerLotKg: number
  isWeighed?: boolean
}

export type RunningOrderSummary = {
  id: string
  product: string
  lots: number
  completedLots: number
  operator: string
  startedAt: string
  productionDuration: string
  supervisorNote: string
  materials: RunningOrderMaterialSummary[]
}

export const runningOrders: RunningOrderSummary[] = [
  {
    id: 'AUF-240718-031',
    product: 'Backdekoration',
    lots: 12,
    completedLots: 4,
    operator: 'L. Müller',
    startedAt: '13.07.2026 · 06:15 Uhr',
    productionDuration: '3 Std. 25 Min.',
    supervisorNote: 'Rezeptur angepasst',
    materials: [
      {
        articleNumber: 'BD-1042',
        description: 'Zuckerstreusel, bunt',
        quantityPerLotKg: 120,
        isWeighed: true,
      },
      {
        articleNumber: 'BD-1178',
        description: 'Schokoraspel, fein',
        quantityPerLotKg: 80,
        isWeighed: true,
      },
      {
        articleNumber: 'BD-1231',
        description: 'Dekorzucker, weiß',
        quantityPerLotKg: 50,
      },
    ],
  },
  {
    id: 'AUF-240718-032',
    product: 'Binde- & Geliermittel',
    lots: 8,
    completedLots: 3,
    operator: 'F. Meyer',
    startedAt: '13.07.2026 · 06:30 Uhr',
    productionDuration: '3 Std. 10 Min.',
    supervisorNote: 'Keine Anpassung',
    materials: [
      {
        articleNumber: 'BG-2014',
        description: 'Pektin, Apfel',
        quantityPerLotKg: 300,
        isWeighed: true,
      },
      {
        articleNumber: 'BG-2039',
        description: 'Agar-Agar, Pulver',
        quantityPerLotKg: 125,
      },
      {
        articleNumber: 'BG-2097',
        description: 'Johannisbrotkernmehl',
        quantityPerLotKg: 75,
      },
    ],
  },
  {
    id: 'AUF-240718-033',
    product: 'Bioland Honige',
    lots: 16,
    completedLots: 7,
    operator: 'L. Müller',
    startedAt: '13.07.2026 · 07:00 Uhr',
    productionDuration: '2 Std. 40 Min.',
    supervisorNote: 'Rezeptur angepasst',
    materials: [
      {
        articleNumber: 'BH-3008',
        description: 'Blütenhonig, Bioland',
        quantityPerLotKg: 150,
        isWeighed: true,
      },
      {
        articleNumber: 'BH-3041',
        description: 'Waldhonig, Bioland',
        quantityPerLotKg: 100,
      },
    ],
  },
  {
    id: 'AUF-240718-034',
    product: 'Öle & Fette',
    lots: 10,
    completedLots: 5,
    operator: 'F. Meyer',
    startedAt: '13.07.2026 · 07:15 Uhr',
    productionDuration: '2 Std. 25 Min.',
    supervisorNote: 'Keine Anpassung',
    materials: [
      {
        articleNumber: 'OF-4022',
        description: 'Sonnenblumenöl, kaltgepresst',
        quantityPerLotKg: 350,
        isWeighed: true,
      },
      {
        articleNumber: 'OF-4056',
        description: 'Kakaobutter, Bio',
        quantityPerLotKg: 150,
      },
    ],
  },
  {
    id: 'AUF-240718-035',
    product: 'Brotaufstriche',
    lots: 20,
    completedLots: 9,
    operator: 'L. Müller',
    startedAt: '13.07.2026 · 07:45 Uhr',
    productionDuration: '1 Std. 55 Min.',
    supervisorNote: 'Rezeptur angepasst',
    materials: [
      {
        articleNumber: 'BA-5013',
        description: 'Haselnussmus, geröstet',
        quantityPerLotKg: 140,
        isWeighed: true,
      },
      {
        articleNumber: 'BA-5064',
        description: 'Kakaopulver, stark entölt',
        quantityPerLotKg: 60,
      },
      {
        articleNumber: 'BA-5098',
        description: 'Rohrzucker, fein',
        quantityPerLotKg: 50,
      },
    ],
  },
  {
    id: 'AUF-240718-036',
    product: 'Fruchtmischung Mustercharge',
    lots: 1,
    completedLots: 0,
    operator: 'F. Meyer',
    startedAt: '13.07.2026 · 08:20 Uhr',
    productionDuration: '1 Std. 20 Min.',
    supervisorNote: 'Keine Anpassung',
    materials: [
      {
        articleNumber: 'FM-6012',
        description: 'Apfelstücke, getrocknet',
        quantityPerLotKg: 45,
        isWeighed: true,
      },
      {
        articleNumber: 'FM-6048',
        description: 'Cranberries, gesüßt',
        quantityPerLotKg: 30,
        isWeighed: true,
      },
      {
        articleNumber: 'FM-6073',
        description: 'Kürbiskerne, geröstet',
        quantityPerLotKg: 18,
      },
      {
        articleNumber: 'FM-6095',
        description: 'Zimt, gemahlen',
        quantityPerLotKg: 2.5,
      },
    ],
  },
]

export const completedRunningOrders: RunningOrderSummary[] = [
  {
    id: 'AUF-240712-019',
    product: 'Schoko-Crunch',
    lots: 10,
    completedLots: 10,
    operator: 'L. Müller',
    startedAt: '12.07.2026 · 06:10 Uhr',
    productionDuration: '4 Std. 18 Min.',
    supervisorNote: 'Keine Anpassung',
    materials: [
      {
        articleNumber: 'SC-1043',
        description: 'Weizenmehl Type 405',
        quantityPerLotKg: 62.5,
        isWeighed: true,
      },
      {
        articleNumber: 'SC-1045',
        description: 'Schokoladenstücke, dunkel',
        quantityPerLotKg: 20,
        isWeighed: true,
      },
      {
        articleNumber: 'SC-1042',
        description: 'Zuckerstreusel, bunt',
        quantityPerLotKg: 12.5,
        isWeighed: true,
      },
    ],
  },
  {
    id: 'AUF-240711-016',
    product: 'Vanille-Knusper',
    lots: 8,
    completedLots: 8,
    operator: 'F. Meyer',
    startedAt: '11.07.2026 · 07:05 Uhr',
    productionDuration: '3 Std. 41 Min.',
    supervisorNote: 'Rezeptur angepasst',
    materials: [
      {
        articleNumber: 'VK-1043',
        description: 'Weizenmehl Type 405',
        quantityPerLotKg: 68,
        isWeighed: true,
      },
      {
        articleNumber: 'VK-1046',
        description: 'Vanillezucker',
        quantityPerLotKg: 6,
        isWeighed: true,
      },
      {
        articleNumber: 'VK-1044',
        description: 'Butter, gesalzen',
        quantityPerLotKg: 34,
        isWeighed: true,
      },
    ],
  },
  {
    id: 'AUF-240710-011',
    product: 'Nuss-Mix Premium',
    lots: 6,
    completedLots: 6,
    operator: 'L. Müller',
    startedAt: '10.07.2026 · 08:30 Uhr',
    productionDuration: '2 Std. 56 Min.',
    supervisorNote: 'Keine Anpassung',
    materials: [
      {
        articleNumber: 'NM-1088',
        description: 'Haselnüsse, geröstet',
        quantityPerLotKg: 52,
        isWeighed: true,
      },
      {
        articleNumber: 'NM-1047',
        description: 'Kakaopulver, stark entölt',
        quantityPerLotKg: 13,
        isWeighed: true,
      },
      {
        articleNumber: 'NM-1092',
        description: 'Mandeln, gehackt',
        quantityPerLotKg: 35,
        isWeighed: true,
      },
    ],
  },
]
